module.exports = __webpack_public_path__ + "assets/2be65ed090f5c23d9c4cf1c75663f09a.png";